import React from "react";
import { CONFIDENCE_META } from "../../lib/fitment";

/**
 * Compact fitment-confidence chip. Renders nothing for unknown confidence.
 * `label` is appended after the tier name (e.g. "2013 FERRARI 488-GTB").
 */
export default function FitmentBadge({ confidence, label, className = "" }) {
  const meta = CONFIDENCE_META[confidence];
  if (!meta) return null;
  return (
    <span
      data-testid={`fitment-badge-${confidence}`}
      className={`inline-flex items-center gap-1.5 text-[10px] uppercase tracking-[0.18em] font-bold font-mono px-2.5 py-1 rounded-sm border ${meta.cls} ${className}`}
    >
      <span aria-hidden>{meta.icon}</span> {meta.label}
      {label ? <span className="opacity-80"> — {label}</span> : null}
    </span>
  );
}
